export enum GeoJsonTypeEnum {
  POINT = "Point",
  POLYGON = "Polygon",
  MULTI_POLYGON = "MultiPolygon",
  MULTI_POINT = "MultiPoint",
}
